module.exports = __webpack_public_path__ + "static/media/52854030_2452974161444427_3956256696044617728_o.5f49e576.jpg";